import styled from 'styled-components';
import { colors } from '../../../theme/colors';
import {
  SelectorContainer as Container,
  SelectorLabelText as LabelText,
  HiddenInput,
} from '../../sharedSelectorStyles';

export { Container, LabelText };

export const HiddenCheckbox = styled(HiddenInput).attrs({ type: 'checkbox' })``;

export const ToggleBackground = styled.div`
  position: relative;
  width: 44px;
  height: 24px;
  background-color: ${(props) => (props.checked ? colors.primary : colors.brandLightGray)};
  border-radius: 50px;
  transition: background-color 0.2s;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px rgba(0, 169, 255, 0.25);
  }
`;

export const ToggleCircle = styled.div`
  position: absolute;
  top: 2px;
  left: ${(props) => (props.checked ? '22px' : '2px')};
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Toggle/components/ToggleStyles.js